<template>
	<nav>
		<ul class="pages">
			<li :class="{'disabled': current == 1}">
				<a href="javascript:;" @click="setCurrent(current - 1)">上一页 </a>
			</li>

			<li v-for="p in grouplist" :class="{'active': current == p.val}">
				<span v-if = "p.text=='...'">...</span>
				<a href="javascript:;"  @click="setCurrent(p.val)" v-else> {{ p.text }} </a>
      </li>

			<li :class="{'disabled': current == totalPage}">
				<a href="javascript:;" @click="setCurrent(current + 1)">下一页</a>
			</li>
		</ul>
	</nav>
</template>
<script>
	export default {
		name: 'pagination',
		data() {
			return {
				current: this.currentPage
			}
		},
		props: {
			total: { // 数据总条数
				type: Number,
				default: 0
			},
			display: { // 每页显示条数
				type: Number,
				default: 20
			},
			currentPage: { // 当前页码
				type: Number,
				default: 1
			},
			pagegroup: { // 分页条数
				type: Number,
				default: 5,
				coerce: function(v) {
					v = v > 0 ? v : 5;
					return v % 2 === 1 ? v : v + 1;
				}
			},
			totalPage: { // 总页数
				type: Number,
				default: 1
			}
		},
		watch:{
			currentPage(curVal,oldVal){
				 if(curVal){
	       	this.currentPage=curVal;
	       	this.current=curVal;
	       }
			}
		},
		computed: {
			grouplist: function () { // 获取分页页码
      var len = this.totalPage, temp = [], list = [], count = Math.floor(this.pagegroup / 2), center = this.current;
      if (len <= this.pagegroup) {
        while (len--) {
          temp.push({text: this.totalPage - len, val: this.totalPage - len});
        }
        ;
        return temp;
      }
      while (len--) {
        temp.push(this.totalPage - len);
      }
      ;
      var idx = temp.indexOf(center);
      (idx < count) && ( center = center + count - idx);
      (this.current > this.totalPage - count) && ( center = this.totalPage - count);
      temp = temp.splice(center - count - 1, this.pagegroup);
      do {
        var t = temp.shift();
        list.push({
          text: t,
          val: t
        });
      } while (temp.length);
      if (this.totalPage > this.pagegroup) {
        (this.current > count + 1) && list.unshift({text: '...', val: list[0].val - 1});
        (this.current < this.totalPage - count) && list.push({text: '...', val: list[list.length - 1].val + 1});
      }
      return list;
    }
		},
		methods: {
			setCurrent: function(idx) {
				if(idx!=this.current &&idx > 0 && idx < this.totalPage + 1) {
					this.current = idx
					this.$emit('pagechange', idx);
				}
			}
		}

	}
</script>

<style scoped>
	nav {
		text-align: center;
	}
	
	.pages {
		overflow: hidden;
		display: inline-block;
		margin: 0 auto;
		margin-top: 50px;
		text-align: center;
	}
	
	.pages li {
		float: left;
		height: 34px;
		line-height: 34px;
		color: #666;
		margin-right: 5px;
	}
	
	.pages a {
		display: inline-block;
		font-size: 14px;
		height: 34px;
		line-height: 34px;
		padding: 0 14px;
		text-decoration: none;
		color: #333;
		border: 1px solid #fff;
	}
	li:hover a{
		background: #FAFBFF;
		border: 1px solid rgba(31,82,255,0.35);
	}
	li.active a{
		border: 1px solid #1F52FF!important;
		color:#1F52FF!important;
	}
</style>


// WEBPACK FOOTER //
// src/components/pagination.vue